import React from "react";
import { Input, Label } from "reactstrap";
import { useSelector } from "react-redux";
import { PathwayFormGrid, PathwayFormGroup } from "../../../_UI/StyledComponents/PathwayForm";
import { Modes } from "../../../_statics/CRUDStatics";
import stringUtils from "../../../_services/string-utils";

const ClientSelectionForConnectedAuthData = (props) => {
    const clientReducer = useSelector((state) => state.client);

    return (
        <>
            <PathwayFormGroup>
                <Label>Verfügbare Accounts & Shops</Label>
                <Input
                    type="select"
                    name="type"
                    disable={clientReducer.editConnectedAuthDataMode === Modes.EDIT}
                    onChange={props.chooseExistingClient}
                    value={props.selectedClientForAuthData}
                >
                    <option value="">auswählen</option>
                    <option value="NEW_CLIENT">neuer Account / Shop</option>
                    {clientReducer.clients &&
                        clientReducer.clients.map((client, index) => (
                            <option key={index} value={client.externalUUID}>
                                {client.name}
                            </option>
                        ))}
                </Input>
            </PathwayFormGroup>
            {stringUtils.equals(props.selectedClientForAuthData, "NEW_CLIENT") && (
                <PathwayFormGrid>
                    <PathwayFormGroup>
                        <Label>Name</Label>
                        <Input
                            type="text"
                            name="name"
                            data-cy="name-field"
                            defaultValue={clientReducer.editClient.name}
                            onChange={props.handleEditClientChange}
                        />
                    </PathwayFormGroup>
                    <PathwayFormGroup>
                        <Label>Notizen</Label>
                        <Input
                            type="text"
                            name="note"
                            data-cy="note-field"
                            defaultValue={clientReducer.editClient.note}
                            onChange={props.handleEditClientChange}
                        />
                    </PathwayFormGroup>
                </PathwayFormGrid>
            )}
        </>
    );
};

export default ClientSelectionForConnectedAuthData;
